<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<form [formGroup]="latlonForm">
    <div cdkTrapFocus
         fxLayout="row" fxLayoutAlign="space-between start">
        <mat-form-field class="latlon">
            <input type="text"
                   formControlName="latlonString"
                   cdkFocusRegionStart
                   cdkFocusInitial
                   matInput placeholder="Lat/Lon" />
        </mat-form-field>
        <button mat-icon-button matTooltip="Go"
                (click)="zoomToLatLon()" [disabled]="!latlonForm.valid">
            <mat-icon svgIcon="check"></mat-icon>
        </button>
        <button mat-icon-button
                matTooltip="Close"
                (click)="closeDialog()"
                cdkFocusRegionEnd>
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    </div>
</form>
